import { useState, useEffect } from "react";
import { API_URL } from "../api";
import { useParams } from "react-router-dom";

import { Textfit } from "react-textfit";
import VariableTextCell from "./VariableTextCell";

import Draggable from "./Draggable";

function Header({ headerPressed, isWork }) {
  const [pageIsWork, setPageIsWork] = useState(null);
  const { slug } = useParams();

  useEffect(() => {
    if (slug && slug.includes("about")) {
      setPageIsWork(false);
    } else {
      setPageIsWork(true);
    }
  }, [slug]);

  return (
    <>
      <button onClick={() =>  headerPressed(true)} id="header_work_cell" className={`cell ${isWork ? 'selected' : 'unselected button'}`}>
        <VariableTextCell text="WORK"  minFontSize={2} maxFontSize={2000} isBold={isWork}/>
      </button>
      
      <Draggable></Draggable>

      <button onClick={() =>  headerPressed(false)} id="header_about_cell" className={`cell ${!isWork ? 'selected' : 'unselected button'}`}>
        <VariableTextCell text="ABOUT" minFontSize={2} maxFontSize={2000} isBold={!isWork}/>
      </button>
      
    </>
  );
}

export default Header;

/*
<div
        id="header_work_cell"
        className="cell anybody-variable"
        ref={(el) => variableRefsArray.current.push(el)}
      >
        <span>WORK</span>
      </div>
*/
/*
<div
        id="header_about_cell"
        className="cell anybody-variable"
        ref={(el) => variableRefsArray.current.push(el)}
      >
        ABOUT
      </div>
*/



/*
<div id="header" className="ibm-plex-mono-light work_selected">
      <div id="header_work_cell" className="cell">
        <span>Work</span>
      </div>
      <div id="header_about_cell" className="cell">
        <span>About</span>
      </div>
    </div>
    */
